/**
 * The Marafye "merge" logo: three orders flowing into one.
 * variant="onDark" for the dark header (light lines, white name), "onLight" for white backgrounds.
 * Source files: public/brand/marafye-mark.svg and marafye-icon.svg.
 */
const COLORS = {
  onLight: { top: "#8CC63F", bottom: "#3C9E23", main: "#1E6B1E", word: "#1E6B1E" },
  onDark: { top: "#CDEBA8", bottom: "#8CC63F", main: "#FFFFFF", word: "#FFFFFF" },
}

export function MarafyeMark({ size = 40, variant = "onLight" }) {
  const c = COLORS[variant]
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <g fill="none" strokeWidth="7" strokeLinecap="round">
        <path d="M8 15 C24 15 25 32 40 32" stroke={c.top} />
        <path d="M8 49 C24 49 25 32 40 32" stroke={c.bottom} />
        <path d="M8 32 H44" stroke={c.main} />
      </g>
      <path d="M42 21 L58 32 L42 43 Z" fill={c.main} stroke={c.main} strokeWidth="3" strokeLinejoin="round" />
    </svg>
  )
}

export default function MarafyeLogo({ size = 40, variant = "onLight", showName = true }) {
  return (
    <span className="marafye-logo d-inline-flex align-items-center" style={{ gap: size * 0.22 }}>
      <MarafyeMark size={size} variant={variant} />
      {showName ? (
        <span
          className="marafye-logo-name"
          style={{ fontSize: size * 0.62, color: COLORS[variant].word }}
        >
          Marafye
        </span>
      ) : (
        <span className="visually-hidden">Marafye</span>
      )}
    </span>
  )
}
